export const QueryKeys = {
  FETCH_CUSTOMER_ACCOUNT_KEY: "fetchCustomerAccount",
  FETCH_CONTACT_DETAILS_KEY: "fetchContactDetails",
  FETCH_DROPDOWN_OPTIONS_KEY: "fetchDropdownOptions",
  FETCH_QUARRY_LOCATIONS_KEY: "fetchQuarryLocations",
  FETCH_BIDTOOL_DATA_KEY: "fetchBidtoolData",
  FETCH_ESTIMATE_QUOTE_KEY: "fetchEstimateQuoteKey",
  FETCH_BID_CONFIG_SETTINGS_KEY: "fetchBidConfigInfo",
  FETCH_DOCUMENTS: "fetchDocuments",
  FETCH_ALL_JOBS_KEY: "fetchAllJobs",
  FETCH_CRM_MAP_KEY: "fetchCrmMapKey",
  FETCH_INDIVIDUAL_JOB: "fetchIndividualJob",
  FETCH_INDIVIDUAL_JOB_DETAIL_KEY: "fetchSingleJobDetail",
  FETCH_USER_ROLE_DATA: "fetchUserRole",
  FETCH_QUOTE_KEY: "fetchQuote",
  FETCH_QUOTE_ESTIMATE_DOCUMENTS_KEY: "fetchQuoteEstimateDocuments",
  SAVE_QUOTE_ESTIMATE_DOCUMENT_KEY: "saveQuoteEstimateDocuments",
  MAKE_DOCUMENT_PRIMARY_KEY: "makeDocumentPrimary",
  FETCH_TICKETS_KEY: "fetchTickets",
  FETCH_TICKET_CUSTOMERS_KEY: "fetchTicketCustomersMeta",
  FETCH_TICKET_TRUCKS_KEY: "fetchTicketTrucksMeta",
  FETCH_TICKET_JOBS_KEY: "fetchTicketJobsMeta",
  FETCH_JOBS_KEY: "fetchJobsMeta",
  FETCH_TICKET_ORDERS_KEY: "fetchTicketOrdersMeta",
  FETCH_TICKET_FILTERS_KEY: "fetchTicketFilters",
  FETCH_TICKET_MATERIALS_KEY: "fetchMaterials",
  FETCH_TICKET_VENDORS_KEY: "fetchVendors",
  FETCH_TICKET_ORDER_NUMBER_KEY: "fetchTicketOrderNumbers",
  FETCH_TICKET_DETAILS_KEY: "fetchTicketDetails",
  FETCH_TICKET_PROCESSING_KEY: "fetchTicketProcessing",
  FETCH_TICKET_PROCESSING_FILTERS_KEY: "fetchTicketProcessingFilters",
  FETCH_APPROVED_TICKETS_KEY: "fetchApprovedTickets",
  FETCH_ARCHIVED_TICKETS_KEY: "fetchArchivedTickets",
  FETCH_TICKET_PROCESSING_REVIEW_LIST_KEY: "fetchTicketProcessingReviewList",
  FETCH_TICKET_PROCESSING_DETAILS_KEY: "fetchTicketProcessingDetails",
  PREFETCH_TICKET_PROCESSING_DETAILS_KEY: "prefetchTicketProcessingDetails",
  FETCH_TICKET_PROCESSING_SECTION_COUNT_KEY:
    "fetchTicketProcessingSectionCounts",
  INVOICE_MANAGEMENT_TILE_KEY: "fetchInvoiceManagementTileKey",
  FETCH_RULE_ENGINE_CONTENT_KEY: "fetchRuleEngineContentKey",
  FETCH_EXTERNAL_ROLES_KEY: "fetchExternalRolesKey",
  FETCH_LIEN_DASHBOARD_KEY: "fetchLienDashboardKey",
  FETCH_LEIN_CUSTOMER_FILTERS_KEY: "fetchLienCustomerFiltersKey",
  FETCH_LEIN_JOB_FILTERS_KEY: "fetchLienJobFiltersKey",
  FETCH_LIEN_DETAILS_KEY: "fetchLienDetailsKey",
  FETCH_BATCH_DOCUMENTS_KEY: "fetchBatchDocumentsKey",
  FETCH_BATCH_DOCUMENTS_ZIP_KEY: "fetchBatchDocumentsZipKey",
  FETCH_LIEN_CUSTOMER_FILTERS_KEY: "fetchLienCustomerFiltersKey",
  FETCH_LIEN_JOB_FILTERS_KEY: "fetchLienJobFiltersKey",
  FETCH_LIEN_MONTH_FILTERS_KEY: "fetchLienMonthFiltersKey",
  FETCH_CONTACTS_TABLES_KEY: "fetchContactsTablesKey",
  FETCH_DOCUMENTS_TABLES_KEY: "fetchDocumentsTablesKey",
  FETCH_NOTES_TABLES_KEY: "fetchNotesTablesKey",
  FETCH_DATABASE_META_KEY: "fetchDatabaseMetaKey",
  FETCH_JOB_TABLES_KEY: "fetchJobTableKey",
  GET_CUSTOMER_DATABASE_KEY: "fetchCustomerDatabaseKey",
  GET_CUSTOMER_PROFILE_KEY: "fetchCustomerProfileKey",
  FETCH_JOB_DATABASE_LISTING_KEY: "fetchJobDatabaseListingKey",
  FETCH_JOB_DATABASE_SUMMARY_KEY: "fetchJobDatabaseSummaryKey",
  FETCH_AFFECTED_JOB_COUNT_KEY: "fetchAffectedJobCountKey",
  FETCH_ORDERS_TABLES_KEY: "fetchOrderTableskey",
  FETCH_JOB_DETAILS_KEY: "fetchJobDetailsKey",
  FETCH_QUARRY_META_KEY: "fetchQuarryMetaKey",
  FETCH_QUARRY_LIST_KEY: "fetchQuarryListKey",
  FETCH_QUARRY_MATERIAL_TYPE_KEY: "fetchQuarryMaterialTypeKey",
  FETCH_QUARRY_MATERIAL_CATEGORY_KEY: "fetchQuarryMaterialCategoryKey",
  FETCH_QUARRY_DETAILS_KEY: "fetchQuarryDetailsKey",
  FETCH_QUARRY_MATERIAL_CATEGORY_LIST_KEY: "fetchQuarryMaterialCategoryList",
  FETCH_ADD_QUARRY_MATERIAL_CATEGORY_KEY: "fetchAddQuarryMaterialCategoryKey",
  FETCH_QUARRY_HEADER_DETAILS_KEY: "fetchQuarryHeaderDetailsKey",
  FETCH_ADD_QUARRY_MATERIAL_SUBCATEGORY_KEY:
    "fetchAddQuarryMaterialSubCategoryKey",
  FETCH_ADD_QUARRY_MATERIAL_NAME_KEY: "fetchAddQuarryMaterialNameKey",
  GET_MATERIAL_IMAGES_KEY: "fetchGetMaterialImagesKey",
  GET_QUARRIES_PRESENT_MATERIALS_KEY: "getQuarriesPresentMaterialsKey",
  GET_ARCHIVE_RECORDS_KEY: "getArchiveRecordsKey",
  FETCH_INVOICE_MANAGEMENT_CUSTOMER_FILTER_KEY:
    "fetchInvoiceManagementCustomerFilterKey",
  FETCH_INVOICE_MANAGEMENT_JOBS_FILTER_KEY: "fetchJobsFilterKey",
  FETCH_INVOICE_MANAGEMENT_ORDERS_FILTER_KEY: "fetchOrdersFilterKey",
  FETCH_INVOICE_MANAGEMENT_INVOICES_FILTER_KEY: "fetchInvoicesFilterKey",
  FETCH_INVOICE_MANAGEMENT_SYNC_STATUS_FILTER_KEY: "fetchSyncStatusFilterKey",
  FETCH_INVOICE_MANAGEMENT_INVOICE_STATUS_FILTER_KEY:
    "fetchInvoiceStatusFilterKey",
  FETCH_INVOICE_MANAGEMENT_LIST_KEY: "fetchInvoiceManagementList",
  FETCH_INVOICE_GENERATION_STATUS_KEY: "fetchInvoiceGenerationStatus",
  FETCH_MATERIAL_CATEGORIES_KEY: "fetchMaterialCategoriesKey",
  FETCH_MATERIAL_TYPE_KEY: "fetchMaterialTypeKey",
  FETCH_MATERIAL_NAME_KEY: "fetchMaterialNamekey",
  FETCH_LOCATION_DETAILS_KEY: "fetchLocationDetailsKey",
  GET_MATERIAL_VENDOR_OPTION_LIST: "getMaterialVendorOptionsList",
  GET_MATERIAL_OPTION_LIST: "getMaterialOptionList",
  GET_DATABASE_PAGINATION_META: "getDatabasePageSizeMeta",
};
